import React, { ReactElement } from 'react';

import {
  Box,
  Button,
  ButtonPattern,
  Container,
  Grid,
  GridItem,
  Heading,
} from '@constellation/core';
import { useContent } from '@interstellar/react-app-content';

import { IdvHardFailureContent } from './IdvHardFailureContent';
import NeedHelpWrapper from 'components/needHelpWrapper/NeedHelpWrapper';
import PageHeading from 'components/pageHeading/PageHeading';
import StyledBox from 'components/style/styledBox/StyledBox';
import { StyledImage } from '../fullSignatoryPage/FullSignatoryPage.styled';

function IdvHardFailure(): ReactElement {
  const { idvHardFailureContent } = useContent<IdvHardFailureContent>();

  return (
    <Container padding="none">
      {idvHardFailureContent &&
        idvHardFailureContent.map(
          ({
            serviceName,
            header,
            somethingWentWrong,
            imageSrc,
            imageAltText,
            backToWebsiteButton,
            backToWebsiteLink,
          }) => (
            <React.Fragment key="content">
              <PageHeading serviceName={serviceName} header={header} />
              <Grid alignX="center" alignY="top">
                <GridItem lg={8}>
                  <StyledBox>
                    <Grid alignX="center" alignY="center">
                      <GridItem sm={12} md={6} lg={6}>
                        <Box
                          bgColor="none"
                          marginTop="07"
                          marginBottom="07"
                          padding="none"
                        >
                          <StyledImage alt={imageAltText} src={imageSrc} />
                        </Box>
                        <Heading align="center">{somethingWentWrong}</Heading>
                      </GridItem>
                      <GridItem>
                        <ButtonPattern marginBottom="none">
                          <Button href={backToWebsiteLink}>
                            {backToWebsiteButton}
                          </Button>
                        </ButtonPattern>
                      </GridItem>
                    </Grid>
                  </StyledBox>
                </GridItem>

                <GridItem lg={4}>
                  <NeedHelpWrapper />
                </GridItem>
              </Grid>
            </React.Fragment>
          ),
        )}
    </Container>
  );
}

export default IdvHardFailure;
